import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormElement } from '@rx-applications/shared/utils-forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsPipeModule } from '@rx-applications/shared/utils';
import { GuestSearchComponent } from '@rx-applications/clientsite-guestbook/api';

@Component({
  selector: 'rx-applications-clientsite-checkout-guests',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, AsPipeModule, GuestSearchComponent],
  templateUrl: './clientsite-checkout-guests.component.html',
  styleUrls: ['./clientsite-checkout-guests.component.scss'],
})
export class ClientsiteCheckoutGuestsComponent extends FormElement implements OnInit {
  @Input() set numberOfGuests(value: number) {
    this.guestsArray = Array.from({ length: value }, (_, i) => i);
  }

  guestsArray: number[];

  constructor() {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }
}
